<template>
    <div>
        <div v-if="buttonInitiated">
            <div
                v-if="isButtonDisable"
                :class="[{ 'disable-red': isButtonDisable }, buttonClass]"
                v-html="buttonLbl"
            ></div>
            <div
                id="redeem_button"
                class="btn-wrapper"
                :class="[{ disable: isButtonDisable }, buttonClass]"
                v-if="!detailController.isLoading"
            >
                <div class="btn-txt" @click="clickRedeem()">
                    {{ campaign.customCaption || "แลกคูปอง" }}
                </div>
            </div>
            <div
                class="btn-wrapper btn-disable"
                v-if="detailController.isLoading"
            >
                <div class="btn-txt" @click="clickRedeem()">
                    {{ lblRedeemBTN.isLoading }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
/**
 * Property
 * @property {boolean} isLogin (required) Is user logged in.
//  * @property {number} point (required) User available point.
 * @property {number} selectedPoint (required) Point amount for redeem campaign.
 * @property {number} selectedQuantity (required) Campaign's quantity.
 * @property {object} lblRedeemBTN (required) Text for component.
 * @property {object} campaign (required) Campaign data.
 * @property {object} redeemBTN (required) Redeem information (redeemable, isDisable etc.).
 *
 * Event
 * @event clickRedeem Callback to parent component when click redeem button.
 * Method
 * @method initialRedeemButton Setup redeem button data (text, redeemable, disable css class, etc.).
 *
 * Utilities
 * @method cleanRedeemButtonLabel Replace \n with <br/>.
 * @method getRedeemButtonClass Get redeem current css class.
 */
import CacheHelper from "@/helper/CacheHelper.js";

export default {
    name: "RedeemButton",
    props: {
        isLogin: Boolean,
        // userPoint: Number,
        profile: Object,
        lblRedeemBTN: Object,
        detailController: Object,
        modalController: Object,
        redeemController: Object,
    },
    data: function () {
        return {
            type: null,
            point: 0,
            pointType: "",
            quantity: 0,
            campaign: {},
            redeemAmount: 1,
            campaignPoint: 0,
            buttonClass: "disable",
            buttonLbl: "",
            buttonInitiated: false,
            isAllowRedeem: false,
            isUseDefault: false,
            cacheHelper: new CacheHelper(),
        };
    },
    mounted: function () {
        this.initialRedeemButton();
        this.buttonClass = this.getRedeemButtonClass();
        this.buttonLbl = this.cleanRedeemButtonLabel();
    },
    created: function () {
        this.type = this.detailController.type;
        this.point = this.detailController.point;
        this.pointType = this.detailController.pointType;
        this.quantity = this.detailController.quantity;
        this.campaign = this.detailController.campaign;
        this.campaignPoint = this.detailController.point;
        this.buttonLbl = this.lblRedeemBTN.default;
        this.isAllowRedeem = this.campaign.isConditionPass;
        this.isButtonDisable = !this.campaign.isConditionPass;
        this.qty = this.detailController.qty;
    },
    methods: {
        //Event
        clickRedeem: function () {
            if (this.isAllowRedeem) {
                if (this.isLogin) {
                    this.$emit("clickRedeem");
                } else {
                    this.modalController.alertModal
                        .clearModal()
                        .setTitle(this.lblRedeemBTN.alert_headline)
                        .setMsg(this.lblRedeemBTN.alert_login_msg)
                        .setBtnOk(this.lblRedeemBTN.alert_ok_btn)
                        .setTag("redeem-btn")
                        .show();

                    this.modalController.alertModal.onClickOk(() => {
                        this.$router.push("/register");
                    });
                }
            }
        },
        //Function
        initialRedeemButton: function () {
            //Check is campaign supported.
            if (
                this.type == Vue.CampaignType.Bid ||
                this.type == Vue.CampaignType.Event ||
                this.type == Vue.CampaignType.Media
            ) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = "notsupport";
                this.buttonLbl = this.lblRedeemBTN.notSupport;
            }

            //Check points
            if (
                this.campaign.pointPerUnit > this.profile.updated_points.points
            ) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = "expired";
                this.buttonLbl = "คะแนนของคุณไม่เพียงพอในการรับสิทธิ์";
            }

            //check published.
            if (this.campaign.statusID != 3) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = "notpublish";
                this.buttonLbl = this.lblRedeemBTN.notPublish;
            }

            //Check expire date.
            if (this.campaign.currentDate > this.campaign.expireDate) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = "expired";
                this.buttonLbl =
                    this.type == Vue.CampaignType.Buy
                        ? this.lblRedeemBTN.campaignExpiredBuy
                        : this.lblRedeemBTN.campaignExpired;
            }
            //Check sold out.
            if (this.qty <= 0) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = "soldout";
                this.buttonLbl =
                    this.type == Vue.CampaignType.Buy
                        ? this.lblRedeemBTN.soldOutBuy
                        : this.lblRedeemBTN.soldOut;
            }
            //Do validate when logged in.
            if (this.isLogin) {
                //Check user enough point.
                if (this.point > this.profile.updated_points.points) {
                    if (this.pointType && this.pointType != "use") {
                        //Get point, do nothing.
                    } else {
                        this.isAllowRedeem = false;
                        this.isButtonDisable = true;
                        this.buttonClass = "notenoughpoint";
                        this.buttonLbl = this.lblRedeemBTN.notEnoughPoint;
                    }
                }
                //Handle common case for custom text.
                if (!this.campaign.isConditionPass) {
                    this.isAllowRedeem = false;
                    this.isButtonDisable = true;
                    //Use api text message.
                    if (this.isUseDefault) {
                        this.buttonClass = "condition";
                        this.buttonLbl = this.campaign.conditionAlert;
                    } else {
                        switch (this.campaign.conditionAlertId) {
                            case 0:
                                //Should not happening (case 0 means this campaign can be redeem).
                                this.buttonLbl = this.lblnone;
                                break;
                            case 1:
                                //Campaign is soldout.
                                this.buttonClass = "soldout";
                                this.buttonLbl =
                                    this.type == Vue.CampaignType.Buy
                                        ? this.lblRedeemBTN.soldOutBuy
                                        : this.lblRedeemBTN.soldOut;
                                break;
                            case 2:
                                //User already redeem to maximun per person.
                                this.buttonClass = "maxperson";
                                this.buttonLbl = this.lblRedeemBTN.maxPerPerson;
                                break;
                            case 3:
                                //Campaign is on cooldown.
                                this.buttonClass = "cooldown";
                                this.buttonLbl =
                                    this.lblRedeemBTN.redeemCoolDown;
                                break;
                            case 4:
                                //Never see this.
                                this.buttonLbl =
                                    this.lblRedeemBTN.exceedBuyPointLimitPerday;
                                break;
                            case 1403:
                                //User cannot redeem due to campaign condition and user level.
                                this.buttonClass = "eligible";
                                this.buttonLbl =
                                    this.lblRedeemBTN.conditionIsInvalid; //Not eligible.
                                break;
                            case 1409:
                                //Campaign is already expire.
                                this.buttonClass = "expired";
                                this.buttonLbl =
                                    this.type == Vue.CampaignType.Buy
                                        ? this.lblRedeemBTN.campaignExpiredBuy
                                        : this.lblRedeemBTN.campaignExpired;
                                break;
                            case 1410:
                                //Campaign is not available.
                                this.buttonLbl =
                                    this.type == Vue.CampaignType.Buy
                                        ? this.lblRedeemBTN
                                              .campaignNotAvailableBuy
                                        : this.lblRedeemBTN
                                              .campaignNotAvailable;
                                break;
                            default:
                                //Other case.
                                this.buttonClass = "condition";
                                this.buttonLbl = this.campaign.conditionAlert;
                                break;
                        }
                    }
                }
            } else {
                this.buttonClass = "allow";

                if (this.campaign.customCaption) {
                    this.buttonLbl = this.campaign.customCaption;
                }
            }
            this.$nextTick(() => {
                this.buttonInitiated = true;
            });
        },
        //Utilities
        cleanRedeemButtonLabel: function () {
            return Util.newLineToBr(this.buttonLbl);
        },
        getRedeemButtonClass: function () {
            if (!this.isAllowRedeem) return this.buttonClass;

            return "allow";
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/input/baseButton.scss";
@import "@/style/_mixin.scss";
.layout-redeem {
    width: 100%;
    padding: 8px 15px 15px;
    text-align: center;
    position: fixed;
    left: 0;
    bottom: 0px;
    background: $color-light-grey-400;
    box-shadow: 0 -2px 5px 0 rgba(0, 0, 0, 0.15);
}
#redeem_button {
    // @include btn-wrapper(100%);
    // border: 1px solid black;
    background: #4d341c;
    color: #fff;
    padding: 9px;
    border-radius: 25px;
    font-size: 16px;
    text-align: center;
    height: 45px;
    line-height: 26px;
    font-family: "PromptSemiBold";
}
.disable {
    background: #777777 !important;
    pointer-events: none;
}

.disable-red {
    background: none !important;
    color: #e73030;
    margin-bottom: 5px;
    margin-top: -5px;
}
</style>
